import { inject, Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { BazisEntityService } from '@bazis/shared/services/entity.service';

/**
 * OrganizationPipe loads an organization info entity by owner id.
 *
 * It calls `BazisEntityService.getOrganizationEntity$` and returns an
 * Observable. Use the `async` pipe in templates to unwrap the value.
 * If `id` is falsy, it returns `of(null)`.
 *
 * Template usage (Angular v20+ syntax):
 *
 *   @if (orgOwnerId as id) {
 *       @let org$ = (id | organization);
 *       @if (org$ | async; as org) {
 *           <span>{{ org?.$snapshot?.name }}</span>
 *       }
 *   }
 */
@Pipe({
    name: 'organization',
    standalone: true,
})
export class OrganizationPipe implements PipeTransform {
    protected entityService = inject(BazisEntityService);

    /**
     * Load organization info by owner id.
     *
     * @param id Owner id string.
     * @returns Observable of organization entity or `of(null)` when id is empty.
     */
    transform(id: string) {
        if (!id) return of(null);

        return this.entityService.getOrganizationEntity$(id);
    }
}
